<template>
    <div class="form-group row align-items-center">
        <label class="col-md-2 mb-md-0 required"> {{ $t('name') }} </label>
        <app-input 
            class="col-md-8" 
            type="text" 
            v-model="selected"
            :placeholder="'Enter the ' + $t('name')" 
        />
    </div>
</template>
 
<script>
    export default {
        name: 'ShortName',
        props: {
            value: {
                type: [String, Number, Object],
                default: null
            },
        },
        computed: {
            selected: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            }
        }
    }
</script>